const employees = {
  icon: 'UsersIcon',
  title: 'New Employees',
  subtitle: 'Manage and review all new company employees.',
  // shows a Refresh button in the header; the page listens with <MainHeader @refresh="…" />
  refresh: true,
  refreshLabel: 'Refresh',
}

export default employees
